import React from 'react'
import Header from './components/header'
import Tabs from './components/tabs'
import Contents from './components/contents'
import { LeftEl, RecordedEl } from './elements'
import { withStoreProvider } from '../../../../../../../Helpers/withStoreProvider'
import RecordedCourseDashboardStore from '../../stores/RecordedCourseDashboardStore'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { AnimateSharedLayout } from 'framer-motion'
import Helmet from '../../../../../../../Components/Helmet/Helmet'
import { Subscribe } from 'unstated'
import CourseStore from '../../../../../Store/CourseStore'
import { Redirect, withRouter } from 'react-router-dom'
import LinkedQnaBanner from './components/Banner/linkedQnaBanner'

const RecordedHome = ({
  match: {
    params: { courseURL, livDemyID },
  },
}) => {
  const { toggleExpanded } = RecordedCourseDashboardStore.useContainer()
  return (
    <Subscribe to={[CourseStore]}>
      {({
        state: { metaDescription, metaTitle, metaSchema, metaKeywords, cover },
      }) => {
        if (!window.location.pathname.startsWith(`/${livDemyID}/course`)) {
          return <Redirect to={`/${livDemyID}/course/${courseURL}`} />
        }
        return (
          <>
            <Helmet
              data={{
                title: metaTitle,
                description: metaDescription,
                image: cover,
                keywords: metaKeywords,
                schema: metaSchema,
              }}
            />

            <AnimateSharedLayout>
              <RecordedEl>
                <LeftEl>
                    <LinkedQnaBanner />
                  <PerfectScrollbar
                    onScrollDown={() => toggleExpanded(false)}
                    onYReachStart={() => toggleExpanded(true)}
                  >
                    <Header />
                    <Tabs />
                  </PerfectScrollbar>
                </LeftEl>
                <Contents />
                {/*<Footer />*/}
              </RecordedEl>
            </AnimateSharedLayout>
          </>
        )
      }}
    </Subscribe>
  )
}

export default withStoreProvider([RecordedCourseDashboardStore])(
  withRouter(RecordedHome),
)
